module.exports = __webpack_public_path__ + "static/media/pplogo.b528c8ea.jpg";